import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

import { LessonStatus } from '@df/interfaces';

@Component({
    selector: 'app-analysis-all-list',
    templateUrl: './analysis-all-list.component.html',
    styleUrls: ['./analysis-all-list.component.scss']
})
export class AnalysisAllListComponent implements OnInit, OnDestroy {
    headerName: string = 'Завершенные уроки';
    lesson_completed = LessonStatus.LESSON_COMPLETED;
    lesson_completed_not_final = LessonStatus.LESSON_COMPLETED_NOT_FINAL;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor() {}

    public ngOnInit(): void {}

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
